import { type ReactElement } from 'react';
import { PsychoCardSkeleton } from '../PsychoCard/components/PsychoCardSkeleton';

const SKELETON_COUNT = 5;

export const PsychologistStepSkeleton = (): ReactElement => (
  <div className="flex flex-col gap-4">
    {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
      <PsychoCardSkeleton key={index} />
    ))}
  </div>
);
